import { Injectable } from '@angular/core';
import { TranslateService } from '../../../api/translate.service';
import { 
  fieldAccountCodeCol,
  fieldAddressLine1Col,
  fieldAddressLine2Col,
  fieldAmountCol,
  fieldApprovedByCol,
  fieldBuildingNameCol,
  fieldCountryCol,
  fieldCreatedByCol,
  fieldCurrencyCol,
  fieldDateCol,
  fieldDistrictCol,
  fieldGreenSpaceCol,
  fieldIdCol,
  fieldInvoiceIdCol,
  fieldInvoiceTypeCol,
  fieldIpMetroCol,
  fieldLocalityCol,
  fieldMiqIdCol,
  fieldOppNumberCol,
  fieldOpportunityCol,
  fieldOpportunityInstallmentCol,
  fieldOpportunitySourceCol,
  fieldPercentageCol,
  fieldPostcodeCol,
  fieldPrimaryEmployeeFunctionalUnitCol,
  fieldPrimaryEmployeeFunctionalUnitIdCol,
  fieldPrimaryEmployeeIdCol,
  fieldPrimaryEmployeeManagingOfficeCol,
  fieldPrimaryEmployeeManagingOfficeIdCol,
  fieldPrimaryEmployeeNameCol,
  fieldProjectDescriptionCol,
  fieldPropertyBaseIdCol,
  fieldPropertyTypeCol,
  fieldRegionCol,
  fieldRepresentedPartyCol,
  fieldRepRolCol,
  fieldSellerNameCol,
  fieldSubmittedByCol,
  fieldSuburbCol,
  fieldTeamCol,
  fieldTextCol,
  fieldTransactionTypeCol
} from '../../../utils/ag-grid/column-defs';
import { ColDef } from 'ag-grid-community';

@Injectable({
  providedIn: 'root'
})
export class FeeSplitsReportService {

  constructor(private translateService: TranslateService) { }

  getHeaders(settings: { middle: any, left: any, right: any }) {
    return [
      {
        header: this.translateService.getTranslation('FINISHLINE_ID'),
        key: 'finishline_id',
        width: 7,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_ID'),
        key: 'invoice_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('TRANSACTION_TYPE'),
        key: 'transaction_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_DT'),
        key: 'invoiced_time',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_TYPE'),
        key: 'invoice_type',
        width: 10,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('TEAM_ID'),
        key: 'team',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CURRENCY'),
        key: 'currency',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_NO'),
        key: 'opportunity_number',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_ID'),
        key: 'opportunity',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_INSTALLMENT_ID'),
        key: 'opportunity_installment_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_SOURCE'),
        key: 'opportunity_source',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('REP_ROLE'),
        key: 'rep_role',
        width: 10,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('REPRESENTED_PARTY'),
        key: 'repped_customer',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PROPERTY_TYPE'),
        key: 'property_type',
        width: 10,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('MIQ_PROPERTY_ID'),
        key: 'miq_property_id',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('BUILDING_NAME'),
        key: 'building_name',
        width: 10,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('ADDRESS_LINE1'),
        key: 'address_line1',
        width: 10,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('ADDRESS_LINE2'),
        key: 'address_line2',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('POSTAL_CODE'),
        key: 'postal_code',
        width: 16,
        style: { ...settings.left },
      },
      {
        header: this.translateService.getTranslation('SUBURB'),
        key: 'suburb',
        width: 16,
        style: { ...settings.left },
      },
      {
        header: this.translateService.getTranslation('DISTRICT'),
        key: 'district',
        width: 16,
        style: { ...settings.left },
      },
      {
        header: this.translateService.getTranslation('LOCALITY'),
        key: 'locality',
        width: 16,
        style: { ...settings.left },
      },
      {
        header: this.translateService.getTranslation('REGION'),
        key: 'region',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('COUNTRY'),
        key: 'country',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_ID'),
        key: 'primary_employee_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_NAME'),
        key: 'primary_employee_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_ID'),
        key: 'primary_employee_functional_unit_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_DESC'),
        key: 'primary_employee_functional_unit',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_ID'),
        key: 'primary_employee_managing_office_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_DESC'),
        key: 'primary_employee_managing_office',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRODUCER_BROKER_EMPID'),
        key: 'producer_employee_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRODUCER_BROKER_NAME'),
        key: 'producer_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CONJUNCTIONAL_AGENT'),
        key: 'conjunctional_agent',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRODUCER_ROLE'),
        key: 'producer_role',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('BROKER_COMPANY_OFFICE'),
        key: 'company_office',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('AFFILIATE_CODE'),
        key: 'affiliate_code',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation(
          'PRODUCER_FUNCTIONAL_UNIT'
        ),
        key: 'producer_functional_unit_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation(
          'PRODUCER_FUNCTIONAL_UNIT_DESCRIPTION'
        ),
        key: 'producer_functional_unit',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation(
          'PRODUCER_MANAGING_OFFICE'
        ),
        key: 'producer_managing_office_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation(
          'PRODUCER_MANAGING_OFFICE_DESCRIPTION'
        ),
        key: 'producer_managing_office',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PROJECT_DESCR'),
        key: 'project_description',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('GREENSPACE'),
        key: 'greenspace',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('ACCOUNT'),
        key: 'account_code',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('FLAT_AMOUNT'),
        key: 'fee',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PERCENT_OUTPUT'),
        key: 'producer_fee_percent',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DISBURSEMENT_ALLOC_AMT'),
        key: 'disbursement',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SMF_AMOUNT'),
        key: 'smf',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('AKOL_DED'),
        key: 'deduction',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CBRE_BROKER_ACTUAL_FEE'),
        key: 'cbre_broker_actual_fee',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation(
          'CONJUNCTIONAL_AGENT_ACTUAL_FEE'
        ),
        key: 'conjunctional_agent_actual_fee',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SELLER_NAME'),
        key: 'seller_name', 
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PROPERTY_BASE_ID'),
        key: 'property_base_id',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('IP_METRO'), 
        key: 'ip_metro', 
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CREATED_BY'),
        key: 'created_by',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SUBMITTED_BY'),
        key: 'submitted_by',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('APPROVED_BY'),
        key: 'approved_by',
        width: 30,
        style: { ...settings.middle },
      },
    ];
  }

  getDataSourceSettings(): ColDef[] {
    return [
      {
        ...fieldIdCol,
        field: 'finishline_id',
        headerName: this.translateService.getTranslation('FINISHLINE_ID'),
      },   
      {
        ...fieldInvoiceIdCol,
        field: 'invoice_id',
        headerName: this.translateService.getTranslation('INVOICE_ID'),
        cellRenderer: null,
      },
      {
        ...fieldTransactionTypeCol,
        headerName: this.translateService.getTranslation('TRANSACTION_TYPE'),
      },
      {
        ...fieldDateCol,
        field: 'invoiced_time',
        headerName: this.translateService.getTranslation('INVOICE_DT'),
      },
      {
        ...fieldInvoiceTypeCol,
        headerName: this.translateService.getTranslation('INVOICE_TYPE'),
      },
      {
        ...fieldTeamCol,
        headerName: this.translateService.getTranslation('TEAM_ID'),
      },
      {
        ...fieldCurrencyCol,
        headerName: this.translateService.getTranslation('CURRENCY'),
      },
      {
        ...fieldOppNumberCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_NO'),
      },
      {
        ...fieldOpportunityCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_ID'),
      },
      {
        ...fieldOpportunityInstallmentCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_INSTALLMENT_ID'),
      },
      {
        ...fieldOpportunitySourceCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_SOURCE'),
      },
      {
        ...fieldRepRolCol,
        field: 'rep_role',
        headerName: this.translateService.getTranslation('REP_ROLE'),
      },
      {
        ...fieldRepresentedPartyCol,
        field: 'repped_customer',
        headerName: this.translateService.getTranslation('REPRESENTED_PARTY'),
      },
      {
        ...fieldPropertyTypeCol,
        field: 'property_type',
        headerName: this.translateService.getTranslation('PROPERTY_TYPE'),
      },
      {
        ...fieldMiqIdCol,
        headerName: this.translateService.getTranslation('MIQ_PROPERTY_ID'),
      },
      {
        ...fieldBuildingNameCol,
        field: 'building_name',
        headerName: this.translateService.getTranslation('BUILDING_NAME'),
      },
      {
        ...fieldAddressLine1Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE1'),
      },      
      {
        ...fieldAddressLine2Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE2'),
      },        
      {
        ...fieldPostcodeCol,
        headerName: this.translateService.getTranslation('POSTAL_CODE'),
      },     
      {
        ...fieldSuburbCol,
        headerName: this.translateService.getTranslation('SUBURB'),
      },      
      {
        ...fieldDistrictCol,
        headerName: this.translateService.getTranslation('DISTRICT'),
      },       
      {
        ...fieldLocalityCol,
        headerName: this.translateService.getTranslation('LOCALITY'),
      },   
      {
        ...fieldRegionCol,
        headerName: this.translateService.getTranslation('REGION'),
      },     
      {
        ...fieldCountryCol,
        headerName: this.translateService.getTranslation('COUNTRY'),
      },          
      {
        ...fieldPrimaryEmployeeIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_ID'),
      },
      {
        ...fieldPrimaryEmployeeNameCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_NAME'),
      },      
      {
        ...fieldPrimaryEmployeeFunctionalUnitIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_ID'),
      },
      {
        ...fieldPrimaryEmployeeFunctionalUnitCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_DESC'),
      },
      {
        ...fieldPrimaryEmployeeManagingOfficeIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_ID'),
      },
      {
        ...fieldPrimaryEmployeeManagingOfficeCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_DESC'),
      },      
      {
        ...fieldPrimaryEmployeeIdCol,
        field: 'producer_employee_id',
        headerName: this.translateService.getTranslation('PRODUCER_BROKER_EMPID'),
      },
      {
        ...fieldPrimaryEmployeeNameCol,
        field: 'producer_name',
        headerName: this.translateService.getTranslation('PRODUCER_BROKER_NAME'),
      },    
      {
        ...fieldTextCol,
        field: 'conjunctional_agent',
        headerName: this.translateService.getTranslation('CONJUNCTIONAL_AGENT'),
      },
      {
        ...fieldRepRolCol,
        field: 'producer_role',
        headerName: this.translateService.getTranslation('PRODUCER_ROLE'),
      },
      {
        ...fieldTextCol,
        field: 'company_office',
        headerName: this.translateService.getTranslation('BROKER_COMPANY_OFFICE'),
      },
      {
        ...fieldTextCol,
        field: 'affiliate_code',
        headerName: this.translateService.getTranslation('AFFILIATE_CODE'),
      },
      {
        ...fieldPrimaryEmployeeFunctionalUnitIdCol,
        field: 'producer_functional_unit_id',
        headerName: this.translateService.getTranslation('PRODUCER_FUNCTIONAL_UNIT'),
      },
      {
        ...fieldPrimaryEmployeeFunctionalUnitCol,
        field: 'producer_functional_unit',
        headerName: this.translateService.getTranslation('PRODUCER_FUNCTIONAL_UNIT_DESCRIPTION'),
      },
      {
        ...fieldPrimaryEmployeeManagingOfficeIdCol,
        field: 'producer_managing_office_id',
        headerName: this.translateService.getTranslation('PRODUCER_MANAGING_OFFICE'),
      },
      {
        ...fieldPrimaryEmployeeManagingOfficeCol,
        field: 'producer_managing_office',
        headerName: this.translateService.getTranslation('PRODUCER_MANAGING_OFFICE_DESCRIPTION'),
      },   
      {
        ...fieldProjectDescriptionCol,
        headerName: this.translateService.getTranslation('PROJECT_DESCR'),
      },
      {
        ...fieldGreenSpaceCol,
        headerName: this.translateService.getTranslation('GREENSPACE'),
      },
      {
        ...fieldAccountCodeCol,
        headerName: this.translateService.getTranslation('ACCOUNT'),
      },
      {
        ...fieldAmountCol,
        field: 'fee',
        headerName: this.translateService.getTranslation('FLAT_AMOUNT'),
      },
      {
        ...fieldPercentageCol,
        field: 'producer_fee_percent',
        headerName: this.translateService.getTranslation('PERCENT_OUTPUT'),
      },
      {
        ...fieldAmountCol,
        field: 'disbursement',
        headerName: this.translateService.getTranslation('DISBURSEMENT_ALLOC_AMT'),
      },
      {
        ...fieldAmountCol,
        field: 'smf',
        headerName: this.translateService.getTranslation('SMF_AMOUNT'),
      },
      {
        ...fieldAmountCol,
        field: 'deduction',
        headerName: this.translateService.getTranslation('AKOL_DED'),
      },
      {
        ...fieldAmountCol,
        field: 'cbre_broker_actual_fee',
        headerName: this.translateService.getTranslation('CBRE_BROKER_ACTUAL_FEE'),
      },
      {
        ...fieldAmountCol,
        field: 'conjunctional_agent_actual_fee',
        headerName: this.translateService.getTranslation('CONJUNCTIONAL_AGENT_ACTUAL_FEE'),
      },
      {
        ...fieldSellerNameCol,
        headerName: this.translateService.getTranslation('SELLER_NAME'),
      },
      {
        ...fieldPropertyBaseIdCol,
        headerName: this.translateService.getTranslation('PROPERTY_BASE_ID'),
      },
      {
        ...fieldIpMetroCol,
        headerName: this.translateService.getTranslation('IP_METRO'),
      },
      {
        ...fieldCreatedByCol,
        headerName: this.translateService.getTranslation('CREATED_BY'),
      },            
      {
        ...fieldSubmittedByCol,
        headerName: this.translateService.getTranslation('SUBMITTED_BY'),
      },
      {
        ...fieldApprovedByCol,
        headerName: this.translateService.getTranslation('APPROVED_BY'),
      },
    ];
  }

}
